import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule).then(() => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw.js').then((sw) => {
      sw.update();
      if (sw.installing) {
        console.log('Service worker installing');
      } else if (sw.waiting) {
        console.log('Service worker installed');
      } else if (sw.active) {
        console.log('Service worker active');
      }
    }).catch(function (error) {
      // registration failed
      console.log('Registration failed with ' + error);
    });
  }
}).catch(err => console.log(err));
